// extracted by mini-css-extract-plugin
export default {"noRoomsContainer":"style_noRoomsContainer__kfLfF","noRoomsIcon":"style_noRoomsIcon__SOyOb","noRoomsDescription":"style_noRoomsDescription__QLB0o"};